export const partLabel = (part) => `${part.mfr_part_number} · SN ${part.serial_number} · ${part.name}`;

export const pointLabel = (id, catalog) => {
  const point = catalog.points.find((p) => p.id === id);
  const machine = catalog.machinery.find((m) => m.id === point?.machinery_id);
  return point ? `${machine?.location_name || ''} / ${machine?.component || 'Equipment'} / ${point.label}` : 'Inventory';
};

export const occupantAt = (id, catalog) => catalog.components.find(
  (c) => c.status === 'installed' && c.current_installation_point_id === id
);

export const serializedPayload = (rows) => rows.map((row) => ({
  component_id: row.component.id,
  action: row.action,
  expected_updated_at: row.component.updated_at,
  expected_source_point_id: row.component.current_installation_point_id || null,
  installation_point_id: row.installation_point_id || null,
  expected_target_component_id: row.outgoing?.id || null,
  expected_outgoing_updated_at: row.outgoing?.updated_at || null,
  outgoing_action: row.outgoing && rows.some((r) => r.component.id === row.outgoing.id && ['install', 'remove'].includes(r.action))
    ? 'planned' : (row.outgoing_action || 'inventory'),
  outgoing_status: row.outgoing_status || 'available',
}));